module.exports = __webpack_public_path__ + "012693f9ad1a883c2b898daedb042a08.png";